import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, RefreshCw, ArrowLeft, CheckCircle2, QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, detailText } from "@/lib/api";

export default function ScanWa() {
  const [wa, setWa] = useState({ loading: true, connected: false, phone: "", qr: null, error: "" });
  const [refreshing, setRefreshing] = useState(false);

  const fetchStatus = async () => {
    try {
      const { data } = await api.get("/public/wa-qr");
      setWa({
        loading: false,
        connected: !!data.connected,
        phone: data.phone || "",
        qr: data.qr || null,
        error: data.error || "",
      });
    } catch (e) {
      setWa({
        loading: false,
        connected: false,
        phone: "",
        qr: null,
        error: detailText(e?.response?.data?.detail) || "Gagal menghubungkan ke WA service",
      });
    }
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleRefreshQr = async () => {
    setRefreshing(true);
    try {
      await api.get("/public/wa-qr");
      await fetchStatus();
    } catch (e) {}
    setRefreshing(false);
  };

  return (
    <div className="min-h-screen w-full bg-[#FFFCF9] text-[#35282C] flex flex-col items-center justify-center p-4 relative selection:bg-[#F9EFF0] selection:text-[#9E4053]">
      <div className="absolute top-4 left-4 z-30 md:top-6 md:left-6">
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#90777D] hover:text-[#BE5366] bg-white/80 backdrop-blur-md px-3.5 py-2 rounded-full border border-[#D3B68C]/30 shadow-sm transition-all"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          <span>Kembali ke Login</span>
        </Link>
      </div>

      <div className="w-full max-w-md bg-white rounded-3xl p-6 sm:p-8 border border-[#F1E5E7] shadow-xl text-center flex flex-col items-center">
        <div className="h-12 w-12 rounded-2xl bg-[#F9EFF0] text-[#BE5366] flex items-center justify-center mb-4">
          <QrCode className="h-6 w-6" />
        </div>

        <h1 className="font-serif-title text-2xl font-bold text-[#35282C] mb-1">
          Koneksi WhatsApp Weddly
        </h1>
        <p className="text-xs text-[#90777D] mb-6 max-w-xs">
          Pindai QR Code di bawah untuk menghubungkan nomor WhatsApp pengirim OTP & Undangan.
        </p>

        {wa.loading ? (
          <div className="h-64 w-64 grid place-items-center rounded-2xl border border-dashed border-[#F1E5E7] bg-[#FFFCF9]">
            <RefreshCw className="h-8 w-8 animate-spin text-[#BE5366]" />
          </div>
        ) : wa.connected ? (
          <div className="w-full p-6 rounded-2xl bg-emerald-50 border border-emerald-200 text-emerald-900 flex flex-col items-center gap-3">
            <CheckCircle2 className="h-10 w-10 text-emerald-600" />
            <div>
              <p className="font-bold text-sm">WhatsApp Terhubung!</p>
              <p className="text-xs text-emerald-700 mt-1 font-mono">
                +{wa.phone}
              </p>
            </div>
            <p className="text-xs text-emerald-600/90 mt-2">
              Layanan OTP dan pengiriman pesan WhatsApp aktif.
            </p>
          </div>
        ) : wa.qr ? (
          <div className="flex flex-col items-center gap-3 w-full">
            <div className="p-3 bg-white rounded-2xl border-2 border-[#BE5366]/20 shadow-md">
              <img src={wa.qr} alt="QR Code WhatsApp" className="h-60 w-60 rounded-xl" />
            </div>
            <p className="text-xs text-[#90777D] max-w-xs mt-2 leading-relaxed">
              Buka WhatsApp di HP Anda &rarr; <strong>Pengaturan</strong> &rarr; <strong>Perangkat Tertaut</strong> &rarr; <strong>Tautkan Perangkat</strong>.
            </p>
          </div>
        ) : (
          <div className="w-full p-6 rounded-2xl bg-amber-50 border border-amber-200 text-amber-900 text-xs">
            <p className="font-bold">Menunggu QR Code dari server…</p>
            <p className="mt-1 text-amber-700">Silakan klik tombol muat ulang di bawah.</p>
          </div>
        )}

        <div className="mt-6 pt-4 border-t border-[#F1E5E7] w-full flex items-center justify-between gap-3">
          <Link to="/login" className="text-xs text-[#BE5366] font-semibold hover:underline">
            &larr; Ke Halaman Login
          </Link>
          <Button
            onClick={handleRefreshQr}
            disabled={refreshing}
            variant="outline"
            size="sm"
            className="rounded-full text-xs border-[#D3B68C]/40"
          >
            <RefreshCw className={`h-3.5 w-3.5 mr-1.5 ${refreshing ? "animate-spin" : ""}`} />
            Perbarui QR
          </Button>
        </div>
      </div>
    </div>
  );
}
